var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04455 16H11.0545V14H9.04455V16ZM10.0495 0C8.72978 0 7.42299 0.258658 6.20373 0.761205C4.98446 1.26375 3.87661 2.00035 2.94343 2.92893C1.05878 4.8043 0 7.34784 0 10C0 12.6522 1.05878 15.1957 2.94343 17.0711C3.87661 17.9997 4.98446 18.7362 6.20373 19.2388C7.42299 19.7413 8.72978 20 10.0495 20C12.7148 20 15.2709 18.9464 17.1556 17.0711C19.0402 15.1957 20.099 12.6522 20.099 10C20.099 8.68678 19.8391 7.38642 19.334 6.17317C18.829 4.95991 18.0888 3.85752 17.1556 2.92893C16.2224 2.00035 15.1145 1.26375 13.8953 0.761205C12.676 0.258658 11.3692 0 10.0495 0ZM10.0495 18C5.61767 18 2.0099 14.41 2.0099 10C2.0099 5.59 5.61767 2 10.0495 2C14.4813 2 18.0891 5.59 18.0891 10C18.0891 14.41 14.4813 18 10.0495 18ZM10.0495 4C8.98339 4 7.96093 4.42143 7.20708 5.17157C6.45322 5.92172 6.0297 6.93913 6.0297 8H8.0396C8.0396 7.46957 8.25136 6.96086 8.62829 6.58579C9.00522 6.21071 9.51645 6 10.0495 6C10.5826 6 11.0938 6.21071 11.4707 6.58579C11.8476 6.96086 12.0594 7.46957 12.0594 8C12.0594 10 9.04455 9.75 9.04455 13H11.0545C11.0545 10.75 14.0693 10.5 14.0693 8C14.0693 6.93913 13.6458 5.92172 12.8919 5.17157C12.1381 4.42143 11.1156 4 10.0495 4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.72a9de19a839863d0d2f4fc2857d07e9.svg";